<template>
  <el-dialog title="Cadastrar Visita" @open="reset" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-form-item label="Data/Hora">
        <el-input v-model="visita.dataHora" v-mask="'##/##/#### ##:##'"/>
      </el-form-item>
      
      <el-form-item label="Cliente" style="width: 100%">
        <el-select v-model="visita.cliente"
          :remote-method="recuperarClientesSelect"
          :loading="loadingClientes"
          value-key="id"
          placeholder=""
          loading-text="Carregando clientes"
          no-data-text="Nenhum cliente encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in clientesDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Atendente" style="width: 100%">
        <el-select v-model="visita.usuario"
          :remote-method="recuperarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder=""
          loading-text="Carregando atendentes"
          no-data-text="Nenhum atendente encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Imóvel">
        <el-input :value="util.formatarEnderecoImovel(imovel)" readonly/>
      </el-form-item>
      
      <el-form-item label="Descrição">
        <el-input rows="6" type="textarea"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="gravar" type="primary" size="small">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import Util from '../../util/funcoes.js'
import URLS from '../../util/urls.js';


export default {
  props: {
    visibility: Boolean,
    visitaSelecionada: Object
  },
  data() {
    return {
      loadingClientes: false,
      loadingUsuarios: false,

      clientesDisponiveis: [],
      usuariosDisponiveis: [],

      visita: {
        dataHora: "",
        descricao: "",
        cliente: { id: 0 },
        usuario: { id: 0}
      }
    }
  },
  computed: {
    ...mapState('imoveisStore', {
      imovel(state) { return state.imovelSelecionado },
      placasDisponiveis(state) { return state.placasDisponiveis }
    }),
    util() { return Util }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('imoveisStore', [
      'gravarVisitaImovel'
    ]),
    reset() {
      if(this.visitaSelecionada != undefined) {
        this.visita = this.visitaSelecionada  
        this.clientesDisponiveis = [this.visitaSelecionada.cliente]
        this.usuariosDisponiveis = [this.visitaSelecionada.usuario]
      } else {
        this.visita = {
          dataHora: this.util.agora(),
          descricao: "",
          cliente: { id: 0 },
          usuario: { id: 0 }
        }
        this.clientesDisponiveis = [];
        this.usuariosDisponiveis = [];
      }
    },
    gravar() {
      let payload = this.visita;
      payload.imoveis = [{ id: this.imovel.id }];
      
      this.showLoading();
      this.gravarVisitaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },
    recuperarClientesSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingClientes = true;

      axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        this.clientesDisponiveis = response.data.lista;
        this.loadingClientes = false;
      }).catch(() => {
        this.clientesDisponiveis = [];
        this.loadingClientes = false;
      });
    },

    recuperarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingUsuarios = true;

      axios.post(URLS.USUARIOS_LISTAR, payload)
      .then((response) => {
        this.usuariosDisponiveis = response.data.lista;
        this.loadingUsuarios = false;
      }).catch(() => {
        this.usuariosDisponiveis = [];
        this.loadingUsuarios = false;
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>